import { render } from "./ManageSalesForcesModal.vue?vue&type=template&id=7f48d556"
import script from "./ManageSalesForcesModal.vue?vue&type=script&lang=js"
export * from "./ManageSalesForcesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__